var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMailIcon = function SvgMailIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:none;stroke:#535353;stroke-linecap:round;stroke-width:2}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 20268",
    d: "m1 2c0-0.5 0.5-1 1-1h15.7c0.6 0 1 0.5 1 1v13c0 0.5-0.4 1-1 1h-15.7c-0.5 0-1-0.5-1-1z",
    className: "s0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 20269",
    d: "m18.7 4.4l-8.8 5.5-8.9-5.5",
    className: "s0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMailIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmVyc2lvbj0iMS4yIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjx0aXRsZT5OZXcgUHJvamVjdDwvdGl0bGU+PHN0eWxlPi5zMHtmaWxsOm5vbmU7c3Ryb2tlOiM1MzUzNTM7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjJ9PC9zdHlsZT48ZyBpZD0iTWFpbCBJY29uIj48cGF0aCBpZD0iUGF0aCAyMDI2OCIgZD0ibTEgMmMwLTAuNSAwLjUtMSAxLTFoMTUuN2MwLjYgMCAxIDAuNSAxIDF2MTNjMCAwLjUtMC40IDEtMSAxaC0xNS43Yy0wLjUgMC0xLTAuNS0xLTF6IiBjbGFzcz0iczAiLz48cGF0aCBpZD0iUGF0aCAyMDI2OSIgZD0ibTE4LjcgNC40bC04LjggNS41LTguOS01LjUiIGNsYXNzPSJzMCIvPjwvZz48L3N2Zz4=";